// extracted by mini-css-extract-plugin
var _1 = "TextFileAddModal_field__4GMjI";
var _2 = "TextFileAddModal_form__mVabF";
var _3 = "TextFileAddModal_inputLabel__9OGnP";
var _4 = "TextFileAddModal_text__HJ0dI";
var _5 = "TextFileAddModal_title__P-e+8";
export { _1 as "field", _2 as "form", _3 as "inputLabel", _4 as "text", _5 as "title" }
